import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from './AlgorithmUrl';
import { AlgorithmFormDataSchema } from '../schema/AlgorithmFormDataSchema';
import { AlgorithmFormDataType } from '../schema/types';

interface AlgorithmQueryParams {
  id: number;
}

const getAlgorithms = (params?: AlgorithmQueryParams) =>
  apiClient
    .get<AlgorithmFormDataType>(expand(AlgorithmUrl.base, params))
    .then((response) => AlgorithmFormDataSchema.parse(response.data));

export const useGetAlgorithmQuery = createApiQueryHook(
  ['data-object-algorithm'],
  getAlgorithms
);
